import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Scrollbar } from 'swiper/modules';
import { Modal } from './modal';

export class Gallery {
    
    constructor(slidesSelector='.article-content img', galleryId='gallery-maker') {
      this.slidesSelector = slidesSelector;
      this.slides = document.querySelectorAll(slidesSelector);
      if(!this.slides) return;
      
      this.galleryId = galleryId;
      this.els;

      this.buildHtml();
      this.cloneImages();
      this.init();
      
    }

    buildHtml() {

      this.elsConf = {
        modal: {el: 'div', id: this.galleryId, class: 'modal'},
        inner: {el: 'div', id: '', class: 'inner'},
        swiper: {el: 'div', id: this.galleryId + '-swiper', class: 'swiper'},
        swiperWrapper: {el: 'div', id: '', class: 'swiper-wrapper'},
        swiperNav: { el: 'div', id: '', class: 'swiper-arrows' },
        swiperPrev: { el: 'div', id: '', class: 'swiper-button-prev' },
        swiperNext: { el: 'div', id: '', class: 'swiper-button-next' },
        closeModal: { el: 'div', id: '', class: 'close' }
      };

      this.els = {};

      for (let key in this.elsConf) {
        const elementConf = this.elsConf[key];
        this.els[key] = this.createElement(elementConf.el, elementConf.id, elementConf.class);
      }
 
      this.els.swiperNav.appendChild(this.els.swiperPrev);
      this.els.swiperNav.appendChild(this.els.swiperNext);
      
      this.els.swiper.appendChild(this.els.swiperWrapper);
      this.els.swiper.appendChild(this.els.swiperNav);

      this.els.inner.appendChild(this.els.swiper);

      this.els.modal.appendChild(this.els.inner);
      this.els.modal.appendChild(this.els.closeModal);

      document.body.appendChild(this.els.modal);
    }
    
    cloneImages() {

      this.slides.forEach((original,i) => {
        
        let slide_num = i + 1;
        let clone = original.cloneNode(true);
        let slide = this.createElement('div', false, 'swiper-slide');
        slide.classList.add('col-12');

        const items = Array.from(clone.children);
        items.forEach(item => {
          slide.appendChild(item);
        });

        slide.setAttribute('data-slide',slide_num);
        this.els.swiperWrapper.appendChild(slide);
    
        original.setAttribute('data-href','#'+this.galleryId);
        original.setAttribute('data-slide',slide_num);
    
      });

    }
      
    init() {
      
      const swiperSelector = '#' + this.els.swiper.id;
      const swiperArgs = {
        slidesPerView: 1,
        loop:true,
        autoplay:false,
        delay:2500,
        centeredSlides : true,
        navigation: {
          nextEl:swiperSelector + ' .swiper-button-next',
          prevEl:swiperSelector + ' .swiper-button-prev',
        },
      };
      Swiper.use([Navigation, Pagination, Autoplay, Scrollbar]);

        const swiperGallery = new Swiper(swiperSelector, swiperArgs);

        new Modal({
          modalSelector:'#'+this.els.modal.id,
          openSelector:this.slidesSelector,
          closeSelector:'#'+this.els.modal.id + ' .close',
          activeClass:themeLocals.activeClass,
          createOverlay:true,
          moveToBody:false,
          openCallback:function(target){
            let slideNum = target.dataset.slide;
            swiperGallery.slideToLoop(slideNum - 1);
          }
        });
      }

    createElement(tag, el_id = false, el_class = false) {
      let el = document.createElement(tag);
      if(el_id) el.id = el_id;
      if(el_class) el.classList.add(el_class);
      return el;
    }
  
}